import { usePathname } from 'next/navigation';

export function useActiveLink(path: string) {
    const pathName = usePathname();
    const checkPath = pathName.startsWith('#');
    const currentPath = path === '/' ? '/' : `${path}`;
    return !checkPath && currentPath === pathName;
}
